import React from "react"

import {
    formatTimestamp,
    getAttachmentPlaceholderImage,
    forceArray
} from "../../config/util-functions"
import BackgroundImage from "./BackgroundImage"
import DownloadButton from "./DownloadButton"

const AttachmentListItem = ({
    thumbnail_url,
    title,
    provider,
    labels,
    showPlaceholderOnError = false,
    creator,
    time,
    timeFormat,
    url,
    mode,
    onDelete
}) => (
    <div className="attachment-item-container list-group-item">
        <BackgroundImage
            classList={["media-item-thumb"]}
            imageUrl={thumbnail_url}
            defaultImageUrl={getAttachmentPlaceholderImage(
                forceArray(labels)[0],
                showPlaceholderOnError
            )}
            errorImageUrl={getAttachmentPlaceholderImage(
                forceArray(labels)[0],
                showPlaceholderOnError
            )}
            isThumbnail={true}
        />
        <div className="attachment-item-text">
            {mode === "edit" && (
                <i
                    className="icon icon-remove pull-right"
                    onClick={onDelete}
                    style={{ marginRight: "0px" }}
                />
            )}
            <h4>{title}</h4>
            <p className="attachment-item-provider">
                {provider || (creator && (creator.full_name || creator.name))}
            </p>
            <div>
                <span>{formatTimestamp(time, timeFormat)}</span>
                {mode === "view" && (
                    <div className="pull-right attachment-item-download-btn">
                        <DownloadButton url={url} title={title} />
                    </div>
                )}
            </div>
        </div>
    </div>
)

export default AttachmentListItem
